<script setup lang="ts">
    import {computed} from 'vue';
    import {productCompare} from '../Store';

    // One CompareItem (Store.ts), spelled out: the SFC compiler can't resolve an imported props type here.
    const props = defineProps<{
        productId: string;
        category: string;
        title: string;
        image: string;
        price: string;
        url: string;
        typeCode: string;
        car: string;
    }>();

    const compare = productCompare();
    const checked = computed(() => compare.isSelected(props));
</script>

<template>
    <label class="mao-checkbox mao-checkbox--slimLabel compare-checkbox">
        <input
            type="checkbox"
            :checked="checked"
            @change="compare.toggle({...props})" />
        <span>Vergelijken</span>
    </label>
</template>

<style scoped>
    .compare-checkbox {
        display: inline-block;
        margin: 8px 0 0;
        cursor: pointer;
    }
</style>
